import React from 'react';
import styles from './styles.css';
import { isProd } from '../../config';

const DirectRolloverRPSConfirmation = () => {
  const rolloverNumber = '1-800-831-1423';
  const scheduleCallLink = isProd()
    ? 'https://trpii.my.site.com/scheduler/s?params=NnMZ2EvaAsJRRdZ6VV86qXormVjZk5PlLiUZwZ4ygmaPvIhfQ7kYd5MjxdGv0M5zgANs6WsORWVCcCLSH46StXbyrzu8YmTu7bS0G8T4Wbapi6lWBo7xFuo4lcSQZT%2FrAk3Hw9%2BOiGluKSBwZPiraw%3D%3D&flowName=GenerateInvitation'
    : 'https://trpii--qual.sandbox.my.site.com/scheduler/s?params=isAzLpTgduwXh8Ws376PfkuwR3oKaUBOo5AGxoD3toL5KoGCa0CS0iqlAKQAGxbFHfUMxL1i9C5S%2FSieG0jmJZR2F0RMMq46FAJE7ktHq4dUcXSfSSKkzrmwd0w1qbSQuRuvsDKOtay0bkC1ANKaGg%3D%3D&flowName=GenerateInvitation';

  return (
    <>
      <section className="next-instructions">
        <div className="step-contents">
          <h3>To complete your rollover, please call us</h3>
          <p>An associate from our team will be happy to help you.</p>
          <div className="call-options-wrapper">
            <div className="call-option">
              <span className="icon-wrapper">
                <span className="icon call-icon" />
                <a
                  rel="noopener noreferrer"
                  className="link"
                  href={`tel:${rolloverNumber}`}>
                  {rolloverNumber}
                </a>
              </span>
              <p className="option-subtitle">Call us directly</p>
              <p>Plan for about 10 minutes</p>
            </div>
            <div className="call-option-separator"> Or </div>
            <div className="call-option">
              <span className="icon-wrapper">
                <span className="icon calendar-icon" />
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  className="link"
                  href={scheduleCallLink}>
                  Schedule A Call
                </a>
              </span>
              <p className="option-subtitle">
                Set up time for us to contact you
              </p>
              <p>Plan for about 10 minutes</p>
            </div>
          </div>
        </div>
      </section>
      <style jsx>{styles}</style>
    </>
  );
};

export default DirectRolloverRPSConfirmation;
